/**
 * 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Channels } from './channels';


export interface CreateNotificationTemplateItem { 
    channelId: Channels;
    subject?: string | null;
    data?: string | null;
}



